import { pdfjs } from 'react-pdf';
import workerSrc from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

let configured = false;

/** Configure a local pdf.js worker (bundled by Vite) to avoid CDN/runtime version mismatches. */
export function setupPdfjsWorker(): void {
  if (configured) {
    return;
  }
  pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;
  configured = true;
}

setupPdfjsWorker();
